import { EEstateType } from '../../../repositories/offer-card/entities/offer/OfferSchema';

export function getEstateTypeTitle(estateType: EEstateType): string {
  if (estateType === EEstateType.Rent) {
    return 'В аренде';
  }

  return 'В собственности';
}
